import React from "react";
import styles from "./dotLoader.module.css";

function DotLoader() {
  return <div className={styles["dots-5"]}></div>;
}

export default DotLoader;
